<template>
    <b-card class="rounded-0 mb-n3">
        <div :class="darkmode ? 'd-flex flex-row justify-content-between border border-secondary rounded mb-3' : 'd-flex flex-row justify-content-between border rounded mb-3'">
            <div class="flex-fill m-2 mt-1">
                <div class="d-flex flex-row justify-content-between align-items-end">
                    <img src="../assets/map/user.svg" width="30em" @click="rangeStatus = -1" style="cursor:pointer;"/>
                    <img src="../assets/interface/block.svg" width="27em" @click="rangeStatus = 0" style="cursor:pointer"/>
                    <img src="../assets/map/car.svg" class="mb-n1" height="30em" width="30em" @click="rangeStatus = 1" style="cursor:pointer;"/>
                </div>
                <b-form-input class="px-2" type="range" :min="-1" number :max="1" v-model="rangeStatus"/>
                <div class="d-flex flex-row justify-content-between align-items-center" style="margin-top:-0.6em;margin-bottom:-0.1em">
                    <span style="cursor:pointer;text-align:left;width:33%" @click="rangeStatus = -1">Suche Mitfahrer</span>
                    <span style="cursor:pointer;text-align:center;width:33%" @click="rangeStatus = 0">Suche Nichts</span>
                    <span style="cursor:pointer;text-align:right;width:33%" class="px-1" @click="rangeStatus = 1">Suche Fahrer</span>
                </div>
            </div>
            <b-button v-b-popover.hover.topleft="popText" style="border-top-left-radius:0;border-bottom-left-radius:0">
                <img src="../assets/interface/hint.svg" 
                    class="mt-n1 mx-n1" 
                    style="filter:invert(1);height:1.2em" 
                />
            </b-button>
        </div>
    </b-card>
</template>

<script>
import { BCard, BFormInput, VBPopover } from "bootstrap-vue"
import { mapGetters } from 'vuex'
export default {
    name: "EinstellungenLoeschenCard",
    components:{
        BCard,
        BFormInput
    },
    directives:{
        'b-popover': VBPopover
    },
    computed: mapGetters(['darkmode']),
    props:{
        value: {}
    },
    watch:{
        rangeStatus: function(){
            this.value.suchStatus = this.rangeStatus == -1 ? 2 : this.rangeStatus
        }
    },
    data(){
        return{
            rangeStatus: this.value.suchStatus == 2 ? -1 : this.value.suchStatus,
            popText: 'Suchst du nach Fahrern, wirst du auf der Karte als Benutzer in blau angezeigt. Auf der Suche nach Mitfahrern, wirst du als Auto in rot angezeigt. Bist du nicht auf der Suche, wirst du nicht angezeigt.'
        }
    }
}
</script>